"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

require("./Counter.scss");

require("./CounterDark.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Counter = function Counter(_ref) {
  var min = _ref.min,
      max = _ref.max,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? 0 : _ref$start,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      onChange = _ref.onChange,
      disabled = _ref.disabled;

  var _useState = (0, _react.useState)(start),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var isNumber = function isNumber(keyCode) {
    return keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105;
  };

  var isFunctionKey = function isFunctionKey(keyCode) {
    return keyCode === 8 || keyCode === 46 || keyCode === 9 || keyCode >= 37 && keyCode <= 40;
  };

  var isSign = function isSign(keyCode) {
    return keyCode === 173 || keyCode === 109 || keyCode === 110 || keyCode === 190;
  };

  var validateMaxMin = function validateMaxMin(counter) {
    var set = max !== undefined ? counter <= max : true;
    return set && min !== undefined ? counter >= min : set;
  };

  var handleKeyDown = function handleKeyDown(e) {
    var keyCode = e.keyCode || e.charCode;
    !isFunctionKey(keyCode) && !isNumber(keyCode) && !isSign(keyCode) && e.preventDefault();
  };

  var handleChange = function handleChange(e) {
    var counter = parseFloat(e.target.value);
    counter = counter ? counter : '';
    validateMaxMin(counter) && setCounter(counter);
  };

  var onBlur = function onBlur() {
    return count === '' ? setCounter(0) : count % step !== 0 && setCounter(fixCount(step * Math.round(count / step)));
  };

  var increment = function increment() {
    var counter = fixCount(count === '' ? 0 + step : count + step);

    if (validateMaxMin(counter)) {
      setCounter(counter);
    }
  };

  var decrement = function decrement() {
    var counter = fixCount(count === '' ? 0 - step : count - step);

    if (validateMaxMin(counter)) {
      setCounter(counter);
    }
  };

  var setCounter = function setCounter(count) {
    setCount(count);
    onChange(count);
  };

  var fixCount = function fixCount(count) {
    return +count.toFixed(2);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-counter'
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: decrement,
    disabled: disabled ? true : min !== undefined ? count === min : false
  }, /*#__PURE__*/_react["default"].createElement("i", {
    "class": "gcl-icon minus"
  })), /*#__PURE__*/_react["default"].createElement("input", {
    className: 'gcl-counter-input ' + (disabled ? 'disabled' : ''),
    type: "number",
    onKeyDown: !disabled && handleKeyDown,
    onChange: !disabled && handleChange,
    onBlur: !disabled && onBlur,
    value: count,
    min: min,
    max: max,
    step: step,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: increment,
    disabled: disabled ? true : max !== undefined ? count === max : false
  }, /*#__PURE__*/_react["default"].createElement("i", {
    "class": "gcl-icon plus"
  })));
};

Counter.propTypes = {
  onChange: _propTypes["default"].func,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  start: _propTypes["default"].number,
  step: _propTypes["default"].number,
  disabled: _propTypes["default"].bool
};
Counter.defaultProps = {
  onChange: function onChange() {},
  start: 0,
  step: 1,
  min: undefined,
  max: undefined,
  disabled: false
};
var _default = Counter;
exports["default"] = _default;